import CustomButton from "Components/Custom/CustomButton";
import React from "react";
import MoreActions, { ActionItem } from "./MoreActions";
import { useAppSelector } from "Components/Hooks/hooks";
import DateRangeSelector from "./DateRangeSelector";

interface ActionButton {
  label: string;
  onClick?: () => void;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  isLoading?: boolean;
  type?: "button" | "dropdown";
  groups?: ActionItem[][];
}

interface PageHeaderActionsProps {
  id?: string;
  title: string;
  subtitle: string;
  actions?: ActionButton[];
  onDateSelect?: (range: { start: Date; end: Date }) => void;
  isDateRangeSelector?: boolean;
}

const PageHeaderActions = ({
  id,
  title,
  subtitle,
  actions = [],
  onDateSelect,
  isDateRangeSelector,
}: PageHeaderActionsProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const role = user?.role;

  return role === "user" ? (
    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
      {/* Left Section */}
      <div className="d-flex flex-column w-50">
        <p className="text-black2D fs-24 fs-sm-20 fs-xs-18 fw-bold font-primary p-0 m-0">
          {title}
        </p>
        <p className="text-grey89 fs-14 fs-xs-12 fw-medium font-primary p-0 m-0">
          {subtitle}
        </p>
      </div>

      {/* Right Section */}
      <div className="d-flex flex-wrap align-items-center gap-2 w-100 w-md-auto justify-content-start justify-content-md-end">
        {actions.map((btn, index) => {
          if (btn.type === "dropdown") {
            return (
              <MoreActions
                key={index}
                label={btn.label}
                groups={btn.groups || []}
              />
            );
          }

          return (
            <CustomButton
              key={index}
              text={btn.label}
              className="bg-primary text-white br-7 px-3"
              id={id}
              leftIcon={btn.leftIcon}
              rightIcon={btn.rightIcon}
              onClick={btn.onClick}
              loading={btn?.isLoading || false}
            />
          );
        })}
      </div>
    </div>
  ) : (
    <div className="d-flex align-items-center justify-content-between">
      {/* Left Section */}
      <div className="d-flex flex-column">
        <p
          className={`${
            isDateRangeSelector
              ? "text-grey89 fs-14  fw-medium"
              : "text-black2D fs-24  fw-bold"
          } font-primary p-0 m-0`}
        >
          {title}
        </p>
        <p
          className={`${
            isDateRangeSelector
              ? "text-black2D fs-24  fw-bold"
              : "text-grey89 fs-14  fw-medium"
          } font-primary p-0 m-0 pb-3`}
        >
          {subtitle}
        </p>
      </div>

      {/* Right Section */}
      {isDateRangeSelector && <DateRangeSelector onDateSelect={onDateSelect} />}
    </div>
  );
};

export default PageHeaderActions;
